export default __webpack_public_path__ + "assets/images/b904c64f660b736ce1c78be6a9f89cf4.jpeg";